// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__31vkV","content":"ManualTimeModal_content__3lljV"};